function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import { Editor, Text } from 'tiptap';
import { HardBreak, Heading, Code, Link, BulletList, OrderedList, Blockquote, CodeBlock, CodeBlockHighlight, HorizontalRule, History, Placeholder } from 'tiptap-extensions';
import { Strong, Italic, Strike } from './marks';
import { Image, PlainTextDocument, ListItem } from './nodes';
import MarkdownIt from 'markdown-it';
import taskLists from 'markdown-it-task-lists';
import { MarkdownSerializer, defaultMarkdownSerializer } from 'prosemirror-markdown';

var loadSyntaxHighlight = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(language) {
    var languages, modules, i, lang;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            languages = [language];
            modules = {};
            i = 0;

          case 3:
            if (!(i < languages.length)) {
              _context.next = 17;
              break;
            }

            _context.prev = 4;
            _context.next = 7;
            return import(
            /* webpackChunkName: "highlight/[request]" */
            'highlight.js/lib/languages/' + languages[i]);

          case 7:
            lang = _context.sent;
            modules[languages[i]] = lang.default;
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", undefined);

          case 14:
            i++;
            _context.next = 3;
            break;

          case 17:
            if (!(Object.keys(modules).length === 0 && modules.constructor === Object)) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return", undefined);

          case 19:
            return _context.abrupt("return", {
              languages: modules
            });

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 11]]);
  }));

  return function loadSyntaxHighlight(_x) {
    return _ref.apply(this, arguments);
  };
}();

var createEditor = function createEditor(_ref2) {
  var content = _ref2.content,
      onInit = _ref2.onInit,
      onUpdate = _ref2.onUpdate,
      extensions = _ref2.extensions,
      enableRichEditing = _ref2.enableRichEditing,
      languages = _ref2.languages;
  var richEditingExtensions = [];

  if (enableRichEditing) {
    richEditingExtensions = [new Heading(), new Code(), new Strong(), new Italic(), new Strike(), new HardBreak(), new HorizontalRule(), new BulletList(), new OrderedList(), new Blockquote(), new CodeBlock(), new ListItem(), new Link(), new Image(), new Placeholder({
      emptyNodeClass: 'is-empty',
      emptyNodeText: 'Add notes, lists or links …',
      showOnlyWhenEditable: true
    })];
  } else {
    richEditingExtensions = [new PlainTextDocument(), new Text(), new CodeBlockHighlight(_objectSpread({}, languages))];
  }

  extensions = extensions || [];
  return new Editor({
    content: content,
    onInit: onInit,
    onUpdate: onUpdate,
    extensions: [].concat(_toConsumableArray(richEditingExtensions), [new History()]).concat(extensions),
    useBuiltInExtensions: enableRichEditing
  });
};

var markdownit = MarkdownIt('commonmark', {
  html: false,
  breaks: false
}).enable('strikethrough').use(taskLists, {
  enable: true,
  labelAfter: true
});

var SerializeException = function SerializeException(message) {
  this.message = message;
};

var createMarkdownSerializer = function createMarkdownSerializer(_nodes, _marks) {
  var nodes = Object.entries(_nodes).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        node = _ref4[1];

    return node.toMarkdown;
  }).reduce(function (items, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        name = _ref6[0],
        toMarkdown = _ref6[1].toMarkdown;

    return _objectSpread({}, items, _defineProperty({}, name, toMarkdown));
  }, {});
  var marks = Object.entries(_marks).filter(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        node = _ref8[1];

    return node.toMarkdown;
  }).reduce(function (items, _ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        name = _ref10[0],
        toMarkdown = _ref10[1].toMarkdown;

    return _objectSpread({}, items, _defineProperty({}, name, toMarkdown));
  }, {});
  return {
    serializer: new MarkdownSerializer(_objectSpread({}, defaultMarkdownSerializer.nodes, {}, nodes), _objectSpread({}, defaultMarkdownSerializer.marks, {}, marks)),
    serialize: function serialize(content, options) {
      return this.serializer.serialize(content, _objectSpread({}, options, {
        tightLists: true
      })).split('\\[').join('[').split('\\]').join(']');
    }
  };
};

var serializePlainText = function serializePlainText(tiptap) {
  var doc = tiptap.getJSON();

  if (doc.content.length !== 1 || typeof doc.content[0].content === 'undefined' || doc.content[0].content.length !== 1) {
    if (doc.content[0].type === 'code_block' && typeof doc.content[0].content === 'undefined') {
      return '';
    }

    throw new SerializeException('Failed to serialize document to plain text');
  }

  var codeBlock = doc.content[0].content[0];

  if (codeBlock.type !== 'text') {
    throw new SerializeException('Failed to serialize document to plain text');
  }

  return codeBlock.text;
};

export default createEditor;
export { markdownit, createEditor, createMarkdownSerializer, serializePlainText, loadSyntaxHighlight };